import { render } from "./Canceled.vue?vue&type=template&id=15dd39ec"
import script from "./Canceled.vue?vue&type=script&lang=js"
export * from "./Canceled.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Canceled.vue?vue&type=style&index=1&id=15dd39ec&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__